// ChunkLoading.jsx
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { color } from '../style/variables.js';
import XGrow from '../style/XGrow.js';

export class ChunkLoading extends React.PureComponent {
  state = { isServer: true };
  nextTick = null;

  componentDidMount() {
    this.nextTick = setTimeout(() => this.setState({ isServer: false }), 0);
  }

  componentWillUnmount() {
    clearTimeout(this.nextTick);
  }

  render() {
    const { isServer } = this.state;
    const { durationSec, color } = this.props;
    return isServer ? (
      <div className="loading-placeholder" />
    ) : (
      <StyledChunkLoading>
        <ProgressBar durationSec={durationSec} color={color} />
      </StyledChunkLoading>
    );
  }
}

ChunkLoading.propTypes = {
  durationSec: PropTypes.number,
  color: PropTypes.string,
};

ChunkLoading.defaultProps = {
  durationSec: 2,
  color: color.tealBlue,
};

const StyledChunkLoading = styled.div`
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100vw;
  height: 4px;
  background-color: ${color.black};
  z-index: 200;
`;

const ProgressBar = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;
  width: 0%;
  height: 100%;
  max-height: 4px;
  background-color: ${({ color }) => color};

  animation: ${({ durationSec }) => durationSec}s forwards ${XGrow};
`;

export default ChunkLoading;
